import {
  SET_PROFILE,
  CHK_ACC_START,
  CHK_ACC_SUCCESS,
  CHK_ACC_FAILURE,
  INIT,
  LOADING,
  ERROR,
  SUCCESS,
  FETCH_CAPB_START,
  FETCH_CAPB_SUCCESS,
  FETCH_CAPB_FAIL,
  SET_BU,
  FETCH_USER_PREFERENCE_START,
  FETCH_USER_PREFERENCE_SUCCESS,
  FETCH_USER_PREFERENCE_FAIL,
  SAVE_USER_PREFERENCE_START,
  SAVE_USER_PREFERENCE_SUCCESS,
  SAVE_USER_PREFERENCE_FAIL,
} from "./profileTypes";

export const initialState = {
  email: "",
  familyName: "",
  givenName: "",
  name: "",
  appAcc: [],
  capb: [],
  phase: INIT,
  bu: "",
  userPreference: {},
  preferenceLoading: false,
  preferenceError: null,
  preferenceSaving: false,
  preferenceSaveError: null,
};

export const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state,
        email: action.payload.email,
        familyName: action.payload.family_name,
        givenName: action.payload.given_name,
        name: action.payload.name,
      };
    case CHK_ACC_START:
      return {
        ...state,
        phase: LOADING,
      };
    case CHK_ACC_SUCCESS:
      return {
        ...state,
        appAcc: action.payload,
        bu: action.payload[0].business_unit,
      };
    case CHK_ACC_FAILURE:
      return {
        ...state,
        phase: ERROR,
      };
    case FETCH_CAPB_START:
      return {
        ...state,
        phase: LOADING,
      };
    case FETCH_CAPB_SUCCESS:
      return {
        ...state,
        capb: action.payload,
      };
    case FETCH_CAPB_FAIL:
      return {
        ...state,
        phase: ERROR,
      };

    case SET_BU:
      return {
        ...state,
        bu: action.payload,
      };

    // Fetch User Preference Cases
    case FETCH_USER_PREFERENCE_START:
      // debugger
      return {
        ...state,
        userPreference: {},
        preferenceLoading: true,
        preferenceError: null,
      };

    case FETCH_USER_PREFERENCE_SUCCESS:
      return {
        ...state,
        userPreference: action.payload,
        preferenceLoading: false,
        preferenceError: null,
      };

    case FETCH_USER_PREFERENCE_FAIL:
      return {
        ...state,
        userPreference: {},
        preferenceLoading: false,
        preferenceError: action.error,
      };

    // Save User Preference Cases
    case SAVE_USER_PREFERENCE_START:
      return {
        ...state,
        preferenceSaving: true,
        preferenceSaveError: null,
      };

    case SAVE_USER_PREFERENCE_SUCCESS:
      return {
        ...state,
        preferenceSaving: false,
        preferenceSaveError: null
      };

    case SAVE_USER_PREFERENCE_FAIL:
      return {
        ...state,
        preferenceSaving: false,
        preferenceSaveError: action.error,
      };

    default:
      return state;
  }
};
